<app-navbar-style-one></app-navbar-style-one>

<div class="out-of-service-container">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-6 col-md-8 col-sm-10">
                <div class="out-of-service-card text-center">
                    <!-- Icon -->
                    <div class="service-icon mb-4">
                        <i class='bx bx-time'></i>
                    </div>

                    <!-- Title -->
                    <h1 class="service-title mb-3">We're Currently Closed</h1>

                    <!-- Message -->
                    <p class="service-message mb-4">
                        Sorry, this vendor is not available at the moment. 
                        We're working hard to serve you during our business hours.
                    </p>

                    <!-- Working Hours -->
                    <div class="working-hours mb-4" *ngIf="workingHours">
                        <h4 class="hours-title mb-3">Working Hours</h4>
                        <div class="hours-content">
                            <p class="hours-text">{{workingHours}}</p>
                        </div>
                    </div>

                    <!-- Loading State -->
                    <div class="working-hours mb-4" *ngIf="!workingHours">
                        <h4 class="hours-title mb-3">Working Hours</h4>
                        <div class="hours-content">
                            <div class="loading-placeholder">
                                <div class="spinner-border text-danger" role="status">
                                    <span class="visually-hidden">Loading...</span>
                                </div>
                                <p class="mt-2">Loading working hours...</p>
                            </div>
                        </div>
                    </div>

                    <!-- Additional Info -->
                    <div class="additional-info mb-4">
                        <p class="info-text">
                            <i class='bx bx-info-circle'></i>
                            We'll be back soon to serve you better!
                        </p>
                    </div>

                    <!-- Home Button -->
                    <button class="btn-home" routerLink="/">
                        <i class='bx bx-home'></i>
                        Go to Homepage
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>

<app-footer-style-two></app-footer-style-two>